import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:5000",
  withCredentials: true,
});

// TEMPORARY: local testing bypass - REMOVE before deploying
const MOCK_MODE = false;

if (MOCK_MODE) {
  apiClient.interceptors.request.use((config) => {
    throw { __mock: true, config };
  });

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.__mock) {
        const url = error.config.url || "";
        let data = {};

        if (url.includes("/login")) {
          data = { token: "fake-token", user: { email: "test@test.com" } };
        } else if (url.includes("/cases")) {
          data = { cases: [] }; // empty list, adjust shape as needed
        } else {
          data = {}; // generic fallback for any other endpoint
        }

        return Promise.resolve({ status: 200, data });
      }

      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
} else {
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
}

export default apiClient;